import * as e from "react";
import { g as I, c as T } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { i as $, a as j } from "./utils-Bf5X_KZD.mjs";
import { F as q } from "./useFormControl-C9UMlaFq.mjs";
import { g as L } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { j as A } from "./jsx-runtime-3tyXYecC.mjs";
import { s as k, u as G, c as H } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { c as N } from "./tss-DN0acMKN.mjs";
import { i as F } from "./isMuiElement-DnSE4qG4.mjs";
function J(o) {
  return I("MuiFormControl", o);
}
L("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const K = (o) => {
  const {
    classes: r,
    margin: l,
    fullWidth: a
  } = o, s = {
    root: ["root", l !== "none" && `margin${N(l)}`, a && "fullWidth"]
  };
  return H(s, J, r);
}, O = k("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: ({
    ownerState: o
  }, r) => ({
    ...r.root,
    ...r[`margin${N(o.margin)}`],
    ...o.fullWidth && r.fullWidth
  })
})({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top",
  // Fix alignment issue on Safari.
  variants: [{
    props: {
      margin: "normal"
    },
    style: {
      marginTop: 16,
      marginBottom: 8
    }
  }, {
    props: {
      margin: "dense"
    },
    style: {
      marginTop: 8,
      marginBottom: 4
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
}), ot = /* @__PURE__ */ e.forwardRef(function(r, l) {
  const a = G({
    props: r,
    name: "MuiFormControl"
  }), {
    children: s,
    className: U,
    color: m = "primary",
    component: h = "div",
    disabled: i = !1,
    error: u = !1,
    focused: S,
    fullWidth: f = !1,
    hiddenLabel: d = !1,
    margin: w = "none",
    required: p = !1,
    size: c = "medium",
    variant: g = "outlined",
    ...B
  } = a, v = {
    ...a,
    color: m,
    component: h,
    disabled: i,
    error: u,
    fullWidth: f,
    hiddenLabel: d,
    margin: w,
    required: p,
    size: c,
    variant: g
  }, D = K(v), [x, P] = e.useState(() => {
    let n = !1;
    return s && e.Children.forEach(s, (t) => {
      if (!F(t, ["Input", "Select"]))
        return;
      const b = F(t, ["Select"]) ? t.props.input : t;
      b && $(b.props) && (n = !0);
    }), n;
  }), [y, W] = e.useState(() => {
    let n = !1;
    return s && e.Children.forEach(s, (t) => {
      F(t, ["Input", "Select"]) && (j(t.props, !0) || j(t.props.inputProps, !0)) && (n = !0);
    }), n;
  }), [R, C] = e.useState(!1);
  i && R && C(!1);
  const E = S !== void 0 && !i ? S : R;
  let M;
  e.useRef(!1);
  const z = e.useMemo(() => ({
    adornedStart: x,
    setAdornedStart: P,
    color: m,
    disabled: i,
    error: u,
    filled: y,
    focused: E,
    fullWidth: f,
    hiddenLabel: d,
    size: c,
    onBlur: () => {
      C(!1);
    },
    onEmpty: () => {
      W(!1);
    },
    onFilled: () => {
      W(!0);
    },
    onFocus: () => {
      C(!0);
    },
    registerEffect: M,
    required: p,
    variant: g
  }), [x, m, i, u, y, E, f, d, M, p, c, g]);
  return /* @__PURE__ */ A.jsx(q.Provider, {
    value: z,
    children: /* @__PURE__ */ A.jsx(O, {
      as: h,
      ownerState: v,
      className: T(D.root, U),
      ref: l,
      ...B,
      children: s
    })
  });
});
export {
  ot as F
};
//# sourceMappingURL=FormControl-C7vROVtA.mjs.map
